import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../../assets/css/sideCustomModal.css';
import { themeSelectorIcons } from '../../assets/images/themeSelector';

const SideCustomModal = ({ setSelectedTheme, selectedTheme, setSelectedSubTheme, selectedSubTheme }) => {
    const navigate = useNavigate();
    const [selectedGames, setSelectedGames] = useState([]);
    const [isRandomMode, setIsRandomMode] = useState(false);

    const gameTypes = [
        {
          id: "mixedwords",
          label: "Mots mélés",
          image: themeSelectorIcons.mixedWords
        },
        {
          id: "fillthegap",
          label: "Texte à trous",
          image: themeSelectorIcons.fillTheGap
        },
        {
          id: "wordmatch",
          label: "Word match",
          image: themeSelectorIcons.wordmatch
        },
        {
          id: "vinyle",
          label: "Vinyle QCM",
          image: themeSelectorIcons.wordmatch
        },
        {
          id: "arrows",
          label: "Arrows QCM",
          image: themeSelectorIcons.wordmatch
        }
    ];

    // const handleCheckboxChange = (value) => {
    //     setSelectedGames(prev =>
    //       prev.includes(value)
    //         ? prev.filter(v => v !== value) // uncheck
    //         : [...prev, value] // check
    //     );
    // };

    const handleCheckboxChange = (value) => {
        setSelectedGames(prev => {
            if (isRandomMode) {
            // 🔹 En mode random : multi sélection
            return prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value];
            } else {
            // 🔹 Sinon : sélection unique
            return prev.includes(value) ? [] : [value];
            }
        });
    };

    const isAnyChecked = Object.values(selectedGames).some((val) => val);

    const handleGamePlay = () => {
        if (selectedGames.length === 0) return;

        let gameSelected;

        if (isRandomMode) {
            // 🔹 Choisir un jeu aléatoire parmi les jeux sélectionnés
            const randomIndex = Math.floor(Math.random() * selectedGames.length);
            gameSelected = selectedGames[randomIndex];
        } else {
            // 🔸 Sélection directe (non aléatoire)
            if (selectedGames.length !== 1) return;
            gameSelected = selectedGames[0];
        }

        // if (selectedGames.length === 1) {
        //     const gameSelected = selectedGames[0];

            switch (gameSelected) {
                case "mixedwords":
                  navigate("/mixedwords", {
                    state: {
                        theme: selectedTheme.name,
                        subTheme: selectedSubTheme
                    }
                  });
                  break;
                case "fillthegap":
                  navigate("/fillthegap", {
                    state: {
                        theme: selectedTheme.name,
                        subTheme: selectedSubTheme
                    }
                  });
                  break;
                case "wordmatch":
                    navigate("/wordmatch", {
                      state: {
                          theme: selectedTheme.name,
                          subTheme: selectedSubTheme
                      }
                    });
                    break;
                case "vinyle":
                    navigate("/vinyleQCM", {
                      state: {
                          theme: selectedTheme.name,
                          subTheme: selectedSubTheme
                      }
                    });
                    break;
                case "arrows":
                    navigate("/arrowsQCM", {
                      state: {
                          theme: selectedTheme.name,
                          subTheme: selectedSubTheme
                      }
                    });
                    break;
                default:
                    navigate("/themeSelevctor")
            }
        
    };

    const handleClose = () => {
        // setSelectedTheme(null);
        setSelectedSubTheme(null);
    };
    return (
        <div className={`side-custom-modal ${selectedSubTheme ? "active" : ""}`}>
            <div className="exit-btn" onClick={handleClose}>
                <img src={themeSelectorIcons.cross} alt="Bouton de fermeture" />
            </div>
            <div className="content">
                <div className="title">
                    <h4>A toi de jouer !</h4>
                    <p>Personnalise ton jeu</p>
                </div>
                <div className="theme-info">
                    <h5>Sélection</h5>
                    <p>Thème : <span>{selectedTheme?.name || "Aucun"}</span></p>
                    <p>Sous-thème : <span>{selectedSubTheme}</span></p>
                    {/* <p>Niveau : <span></span></p> */}
                </div>
                <div className="difficulty-range">
                    <h5>Niveau de difficulté</h5>
                    {/* <input type="range" name="difficulty" id="gameDifficulty" list="levels" min="1" max="5" value="2" step="1">
                    <datalist id="levels">
                        <option value="1"></option>
                        <option value="2"></option>
                        <option value="3"></option>
                        <option value="4"></option>
                        <option value="5"></option>
                    </datalist> */}
                    <div id="slider-range"></div>
                </div>
                <div className="random-mode">
                    <p>Mode aléatoire</p>
                    <label className="switch">
                        <input
                        type="checkbox"
                        checked={isRandomMode}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setIsRandomMode(checked);

                            // 🔸 Si on désactive le mode random, on garde uniquement la première sélection
                            if (!checked && selectedGames.length > 1) {
                            setSelectedGames([selectedGames[0]]);
                            }
                        }}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div className="game-types">
                    <h5>Types de jeux</h5>
                    {gameTypes.map(game => (
                        <div className="type" key={game.id}>
                            <label htmlFor={game.id}>
                            {game.label}
                            <input
                                type="checkbox"
                                id={game.id}
                                value={game.id}
                                checked={selectedGames.includes(game.id)}
                                onChange={() => handleCheckboxChange(game.id)}
                            />
                            <span className="checkmark"></span>
                            </label>

                            <div className={`game-info ${selectedGames.includes(game.id) ? 'open' : ''}`}>
                            <div className="game-info-content">
                                <img className="info-icon" src={themeSelectorIcons.info} alt="Fermer" />
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                <img className="info-img" src={game.image} alt={game.label} />
                            </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="side-modal-btn play">
                <button onClick={handleGamePlay} style={{ backgroundColor: isAnyChecked ? "#EB6424" : "lightgray", pointerEvents: isAnyChecked ? "auto" : "none"}}>Jouer !</button>
            </div>
        </div>
    );
};


export default SideCustomModal;